import type { ReactNode } from 'react';
import React from 'react';
import { useStyletron } from 'baseui';
import { LabelMedium } from 'baseui/typography';
import type { StyleObject } from 'styletron-react';
export const SectionWrapper = ({
  title,
  children,
  style,
  wrapperTitleColor
}: {
  title?: ReactNode;
  children: ReactNode;
  style?: StyleObject;
  wrapperTitleColor?: string;
}) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale500,
    paddingTop: theme.sizing.scale600,
    paddingBottom: theme.sizing.scale600,
    ...style
  })}>
      {title && <LabelMedium margin={0} padding={0} {...wrapperTitleColor && {
      color: wrapperTitleColor
    }}>
          {title}
        </LabelMedium>}
      <section>{children}</section>
    </div>;
};